const state = {
    form: {
    },
};

const mutations = {
    SET_FORM: (state, info) => {
        state.form = info;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};
